/** Textos fijos del certificado HT (plantilla Invoice 5019 — sin color en export). */

export const HT_EMPRESA_HEADER = {
  d7: 'TQF SC COCAL DO SUL ',
  e7: 'Telefone:                    5133966161',
  d8: 'CNPJ: 07547156000640 ',
  e8: 'Insc. Estadual:           255510691',
  d9: 'AVENIDA BEIRA RIO 000473',
  e9: 'Cidade:                      COCAL DO SUL / SC',
  d10: 'CEP: 88845000',
  e10: 'Reg. CREA:               BR SC 416',
  d11: 'E-mail:cac@bioseta.com.br MAPA BR-SC 416',
  e11: 'MAPA BR-SC 416',
};

export const HT_TITULO_PT = 'CERTIFICADO DE TRATAMENTO FITOSSANITÁRIO ';
export const HT_TITULO_EN = 'CERTIFICATE OF PHYTOSANITARY TREATMENT';

export const HT_INTRO_PT =
  'Eu, DENILSON G. PADILHA (ENG FLORESTAL/CREA SC0745868), abaixo assinado, responsável técnico da empresa acima, CERTIFICO ter realizado tratamento fitossanitário com fins quarentenários, conforme legislação em vigor, nos produtos abaixo descritos: ';
export const HT_INTRO_EN =
  'The undersigned, technical manager of the company referred above, certifies that made phytosanitary treatment for quarantine purposes, according to laws in force, in products:';

/** Línea en blanco entre PT (tras descritos:) y párrafo EN completo. */
export const HT_INTRO = `${HT_INTRO_PT}\n\n${HT_INTRO_EN}`;

export const HT_PRODUCTS_LABEL =
  'Descrição Produtos/Embalagem de Madeira \nProducts';
/** Fila 19: una línea, centrada en celda. */
export const HT_PRODUCTS_HEADER_LINE =
  'Descrição Produtos/Embalagem de Madeira / Products';
export const HT_QTY_HEADER_LINE = 'Quantidade/Quantity:';
export const HT_PRODUCTS_VALUE = 'PALLETS / BUNDLES / SUPORTES';

export const HT_EXPORTADOR_LABEL = 'Nome End. Exportador:';
export const HT_EXPORTADOR_VALUE =
  'PALM TRADE BRASIL IMPORTACAO E EXPORTACAO LTDA AVENIDA PREFEITO ALBERTO NATALINO MIQUELUTE, 6777\nSALA:214;BOX:04, ITINGA, ARAQUARI, SC, BRASIL, CEP: 89245000';
export const HT_EXPORTADOR_LABEL_EN = 'Name/Adress of Consignor';

export const HT_IMPORTADOR_LABEL = 'Nome End. Importador:';
export const HT_IMPORTADOR_LABEL_EN = 'Name/Adress of Consignee';

export const HT_ORIGIN_LABEL = 'Lugar de Origem / Origin:';
export const HT_DEST_LABEL = 'Destino / Destination:';

export const HT_MODALITY_TITLE = 'MODALIDADE DE TRATAMENTO / Treatment Modality';
export const HT_MODALITY_LINE =
  '( ) Secagem Estufa-KD (X) Ar Quente forçado-HT ( ) Aquecimento dielétrico-HT';
export const HT_MODALITY_SUB =
  'Kiln Drying                            Forced hot air                                                     Dielectric heating';

export const HT_LOT_LINE =
  'Número de lote / Lot number: 79413532';
export const HT_CYCLE_LINE =
  'Número de ciclo de tratamento / treatment cycle number: 00000022';

export const HT_QTY_TREATED_LABEL = 'Quantidade material tratado / Quantity';
export const HT_TREATMENT_PARAMS_LABEL = 'Pârametros de Tratamento / Treatment parameter';

export const HT_SCIENTIFIC_LABEL = 'Nome material tratado / Scientific name:';
export const HT_SCIENTIFIC_VALUE = ' Suporte /Pallet ';
export const HT_TEMP_ACTUAL = 'Temperatura °C/ Temperture °C : 66,00 °C';

export const HT_DATE_TREAT_LABEL = 'Data do tratamento / Date of treatment:';
export const HT_TEMP_PARAM = 'Parametro de Temperatura / Temperature parameter: 75 °C';

export const HT_TIME_LABEL = 'Horário do tratamento / Treatment  time:';
export const HT_TIME_VALUE =
  'Início/Start: 08h19m - Término / End: 09h31m ';
export const HT_EXPOSURE = 'Tempo de Exposição / Exposure Time: 72 min';

export const HT_PLACE_TREAT_LABEL = 'Local do Tratamento';
export const HT_PLACE_TREAT_SUFFIX = '/ Place of treatment: Centro D. E. / SC';
export const HT_PLACE_TREAT = `${HT_PLACE_TREAT_LABEL} ${HT_PLACE_TREAT_SUFFIX}`;

export const HT_REMARK_LABEL = 'Observação / Remark: B.L./ Invoice:';

export const HT_SHIPPING_DESC = 'DESCRIÇÃO DE REMESSA / Description of shipping';
export const HT_GROSS_LABEL = 'Peso Bruto / Gross weight:';
export const HT_NET_LABEL = 'Peso Líquido / Net weight:';
export const HT_VOLUME_LABEL = 'Número e descrição volume / Description';

export const HT_TRANSPORT_HEADER = 'Meio de transporte / Transport';
export const HT_ROAD = '( ) Rodoviário / Road';
export const HT_AIR = '( ) Aéreo / Air';
export const HT_SEA = '( X) Maritimo / Sea';
/** Línea 50: opciones con espacio amplio entre cada ( ). */
export const HT_TRANSPORT_OPTIONS_LINE = `${HT_ROAD}        ${HT_AIR}        ${HT_SEA}`;

export const HT_MARKS_LABEL = 'Marcas distintivas / Distinctive mark:';
export const HT_MARKS_SUB = '(identificação do contêniner, navio, etc.)';

export const HT_DIGITAL_SIG = 'Assinatura digital validada por Autoridade';
export const HT_ICP_VALIDATION_LINES = [
  'Assinatura digital validada por Autoridade',
  'Certificadora AC 1º Nivel /ICP - Brasil',
];
export const HT_DIGITAL_SIGNATORY_BLOCK =
  'DENILSON\nGONCALVES\nPADILHA:\n00363896929';
export const HT_DIGITAL_SIGNED_BY = 'DENILSON GONCALVES\nPADILHA: 00363896929';
export const HT_ISSUE_PLACE_LABEL = 'Local de Emissão';
export const HT_ISSUER = 'Certificadora AC 1º Nivel /ICP - Brasil';
export const HT_ISSUE_PLACE_EN = 'Place of issue';
export const HT_CITY_ISSUE = 'COCAL DO SUL ';
export const HT_DATE_LABEL = 'Data/Date';

export const HT_TECH_SIGN =
  'DENILSON G. PADILHA (ENG FLORESTAL/CREA SC0745868)';
export const HT_TECH_SIGN_EN = "Technician's signature";
